import React, { ReactNode, useRef, useState } from "react";
import { Dialog } from "@headlessui/react";
import { ExclamationCircleIcon } from "@heroicons/react/outline";
import Button from "components/Button";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import Modal from "../Modal";

export default function ConfirmButton({
  onConfirm,
  children,
  leadingIcon,
  trailingIcon,
  disable,
  className,
}: {
  onConfirm: () => void;
  children: ReactNode;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  disable?: boolean;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const cancelButtonRef = useRef(null);

  const confirm = () => {
    onConfirm?.();
    setOpen(false);
  };

  return (
    <>
      <Modal
        isOpen={open}
        setIsOpen={close}
        containerClassName={clsx("p-10")}
        inProgress={false}
        closeButton={false}
      >
        <div className="sm:flex items-center">
          <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationCircleIcon
              className="h-6 w-6 text-red-600"
              aria-hidden="true"
            />
          </div>
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <Dialog.Title
              as="h3"
              className="text-lg font-medium leading-6 text-gray-900"
            >
              {t("commons.areYouSure")}
            </Dialog.Title>
          </div>
        </div>
        <div className="items-center mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
            onClick={confirm}
          >
            {t("commons.yes")}
          </button>
          <button
            type="button"
            className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm"
            onClick={() => setOpen(false)}
            ref={cancelButtonRef}
          >
            {t("commons.no")}
          </button>
        </div>
      </Modal>
      <Button
        type="danger"
        onClick={() => setOpen(true)}
        leadingIcon={leadingIcon}
        trailingIcon={trailingIcon}
        disable={disable}
        className={className}
      >
        {children}
      </Button>
    </>
  );
}
